import * as React from 'react';
import cn from 'classnames';
import _ from 'lodash';
import styles from './work-item-details.module.css';
import Dropdown, { DropdownOption } from '../../components/Dropdown';
import { WaiverWorkItem, WaiverWorkItemAction } from '../../types/waiverWorkItem';

type Props = {
  workItem: WaiverWorkItem;
  workItemActions: WaiverWorkItemAction[];
  executeAction: (action: WaiverWorkItemAction, workItem: WaiverWorkItem) => void;
};

const WaiverWorkItemActionPicker: React.FC<Props> = ({
  workItem,
  workItemActions,
  executeAction,
}) => {
  const options: DropdownOption<string>[] = workItemActions.map(action => ({
    value: action.name,
    text: action.description,
  }));
  const actionsByValue: { [key: string]: WaiverWorkItemAction } = _.keyBy(
    workItemActions,
    'name',
  );

  return (
    <div className={cn(styles.actionPicker, styles.workItemInput)}>
      <Dropdown
      id="waiverWorkItemActionPicker"
      options={options}
      onChange={value => executeAction(actionsByValue[value as string], workItem)}
      placeholder="Select an Action"
      />
    </div>
  );
};

export default WaiverWorkItemActionPicker;